import { Modal, Button, Form } from 'react-bootstrap';

export const ConfirmationActionPopup = ({ action, numberOfIssues, setTakeActionToAll, onShow, onClose }) => {

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleAction = (takeActionToAll) => {
        setTakeActionToAll(takeActionToAll);
        handleClose();
    };

    if (onShow) {
        document.body.classList.add('modal-open');
    } else {
        document.body.classList.remove('modal-open');
    }

    return (
        <div>
            <Modal
                className="clear-background"
                show={onShow}
                tabIndex="-1"
                onHide={handleClose}
                backdrop="static"
                backdropClassName="custom-backdrop-class"
                style={{ top: '150px' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        {/* Replace Form.Label with h5 since it's not labeling a form control */}
                        <h5 className='mt-2 mb-5'><strong>Are you sure you want to {action} these {numberOfIssues} issues?</strong></h5>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center align-items-center flex-column">
                    <Button
                        variant="primary"
                        onClick={() => handleAction(true)}
                    >
                        <strong>{action === "save" ? "SAVE" : action === "close" ? "CLOSE" : "REOPEN"} ALL ISSUES</strong>
                    </Button>
                    <Button
                        variant="link"
                        className="text-danger"
                        onClick={() => handleAction(false)}
                    >
                        {action === "save" ? "Save" : action === "close" ? "Close" : "Reopen"} only the first issue
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}